import { ValidationErrors } from '@angular/forms';
import {
  areIntervalsOverlapping,
  differenceInHours,
  endOfDay,
  format,
  isSameDay,
  startOfDay,
} from 'date-fns';

import {
  RoomBookingFormModel,
  RoomSettingsBlockingTimeModel,
} from '@bookly/shared';

export function blockingTimeValidator(
  blockingTimes: RoomSettingsBlockingTimeModel[]
) {
  return (formGroup: RoomBookingFormModel): ValidationErrors | null => {
    const startDate = formGroup.controls.startDate;
    const endDate = formGroup.controls.endDate;
    const startHour = formGroup.controls.startHour;
    const endHour = formGroup.controls.endHour;
    if (startDate.value && endDate.value && startHour.value && endHour.value) {
      if (!isSameDay(startDate.value, endDate.value)) {
        return null;
      }
      const start = new Date(
        format(startDate.value, 'yyyy-MM-dd') +
          'T' +
          format(startHour.value, 'HH:mm')
      );
      const end = new Date(
        format(endDate.value, 'yyyy-MM-dd') +
          'T' +
          format(endHour.value, 'HH:mm')
      );
      const some = blockingTimes.some(blockingTime =>
        isOverlapping(start, end, blockingTime)
      );
      if (some) {
        startHour.setErrors({ error: true });
        endHour.setErrors({ error: true });
        return { blockingOverlap: true };
      }
    }
    return null;
  };
}

function isOverlapping(
  start: Date,
  end: Date,
  blockingTime: RoomSettingsBlockingTimeModel
): boolean {
  // If difference > 24h then it will always include blockingTime
  if (differenceInHours(start, end) >= 24) {
    return true;
  } else if (isSameDay(start, end)) {
    return areIntervalsOverlapping(
      { start, end },
      {
        start: new Date(start.toDateString() + ' ' + blockingTime.from),
        end: new Date(start.toDateString() + ' ' + blockingTime.to),
      }
    );
  } else {
    return (
      areIntervalsOverlapping(
        { start, end: endOfDay(start) },
        {
          start: new Date(start.toDateString() + ' ' + blockingTime.from),
          end: new Date(start.toDateString() + ' ' + blockingTime.to),
        }
      ) ||
      areIntervalsOverlapping(
        { start: startOfDay(end), end },
        {
          start: new Date(end.toDateString() + ' ' + blockingTime.from),
          end: new Date(end.toDateString() + ' ' + blockingTime.to),
        }
      )
    );
  }
}
